import { render, staticRenderFns } from "./Bestsellers.vue?vue&type=template&id=1faa524a&scoped=true"
import script from "./Bestsellers.vue?vue&type=script&lang=js"
export * from "./Bestsellers.vue?vue&type=script&lang=js"
import style0 from "./Bestsellers.vue?vue&type=style&index=0&id=1faa524a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa524a",
  null
  
)

export default component.exports